var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',{scopedSlots:_vm._u([{key:"links",fn:function(props){return [_c('sidebar-item',{attrs:{"link":{
            name: _vm.menu_trans,
            icon: 'fa fa-database text-info',
            icon: 'ni ni-shop text-primary'
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.menu_trans,
              icon: 'fa fa-database text-info',
              path: '/lmg/transaction'
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.menu_invoice,
              icon: 'fa fa-database text-info',
              path: '/lmg/invoice'
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.menu_payment,
              icon: 'fa fa-database text-info',
              path: '/lmg/payment'
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.menu_wht,
              icon: 'fa fa-database text-info',
              path: '/lmg/wht'
            }}}),(_vm.IsAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: _vm.menu_cash_clear,
              icon: 'fa fa-database text-info',
              path: '/lmg/cashclear'
            }}}):_vm._e()],1),(_vm.IsAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: _vm.menu_billing_report,
              icon: 'fa fa-reports text-info',
              path: '/lmg/billingreport'
            }}}):_vm._e(),(_vm.IsAdmin)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.menu_database,
            icon: 'fa fa-database text-primary'
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.menu_customer,
              icon: 'fa fa-database text-info',
              path: '/lmg/customer'
            }}})],1):_vm._e(),(_vm.IsAdmin)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.menu_setting,
            icon: 'ni ni-settings text-primary'
          }}},[(_vm.IsAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: _vm.menu_bank,
              icon: 'fa fa-database text-info',
              path: '/lmg/bank'
            }}}):_vm._e(),(_vm.IsAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: _vm.menu_insure,
              icon: 'fa fa-database text-info',
              path: '/lmg/insurance'
            }}}):_vm._e(),(_vm.IsAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: _vm.menu_ttype,
              icon: 'fa fa-database text-info',
              path: '/lmg/transactiontype'
            }}}):_vm._e(),(_vm.IsAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: _vm.menu_comm,
              icon: 'fa fa-database text-info',
              path: '/lmg/commission'
            }}}):_vm._e(),(_vm.IsAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: _vm.menu_person,
              icon: 'fa fa-database text-info',
              path: '/lmg/person'
            }}}):_vm._e()],1):_vm._e(),(_vm.IsAdmin)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.menu_admin,
            icon: 'ni ni-single-02 text-primary'
          }}},[(_vm.IsAdmin)?_c('sidebar-item',{attrs:{"link":{
              name: _vm.menu_user,
              icon: 'fa fa-database text-info',
              path: '/lmg/user'
            }}}):_vm._e()],1):_vm._e(),_c('a',{staticClass:"sidebar-menu-item nav-link",on:{"click":function($event){return _vm.handleLogout()}}},[_c('i',{staticClass:"ni ni-lock-circle-open text-primary"}),_c('span',{staticClass:"nav-link-text"},[_vm._v(" "+_vm._s(_vm.menu_logout))])])]}}])}),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }